import { inject, Injectable } from '@angular/core'
import { SharedApiService } from './util.service'

@Injectable({ providedIn: 'root' })
export class AnnouncementService {
    private sharedApiService = inject(SharedApiService)

    getDetectedAnnouncements(filter: any) {
        return this.sharedApiService.getWithFilter('Announcement/GetByPageAndSection', filter);
    }
}
